import {isNil} from 'ramda';

import {
  VehicleFinancingBalloonPayment,
  VehicleFinancingDownPayment,
  VehicleFinancingTerm,
} from '@dms/api/sales';

import {Nullish} from 'shared/web';

import {RATE_MATRIX_CELL_KEY_SEPARATOR} from '../constants/RATE_MATRIX_CELL_KEY_SEPARATOR';

interface RateMatrixCellCoordinates {
  term: VehicleFinancingTerm;
  downPayment: VehicleFinancingDownPayment;
  balloonBracket: VehicleFinancingBalloonPayment | Nullish;
}

export function buildRateMatrixCellKey(coordinates: RateMatrixCellCoordinates): string {
  const balloonSegment = isNil(coordinates.balloonBracket)
    ? ''
    : coordinates.balloonBracket.toString();

  return [coordinates.term.toString(), coordinates.downPayment.toString(), balloonSegment].join(
    RATE_MATRIX_CELL_KEY_SEPARATOR
  );
}
